import { OptimusProvider, PageLayout, QueryBoundary, useBreadcrumbs } from '@mews-commander/ui';
import { TemplateForm } from '../components/templateForm/TemplateForm';

export const TemplateCreate = () => {
    const breadcrumbs = useBreadcrumbs();
    return (
        <OptimusProvider density="spacious">
            <PageLayout breadcrumbs={breadcrumbs} padded>
                <QueryBoundary loader="overlay">
                    <TemplateForm />
                </QueryBoundary>
            </PageLayout>
        </OptimusProvider>
    );
};
